import { styled } from '@mui/material/styles';

export default styled(({ h, times, ...rest }) => <span {...rest} />)<{ h?: number; times?: number }>`
  display: block;
  height: ${({ h, times = 1 }) => `${h ?? times * 22}px`};
`;
